import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import { Select } from '../styledSystem/Select';
import { BoxTemplate } from '../styledSystem/Box';
import Option from '../styledSystem/Option';
import { Label } from '../styledSystem/Text';

const ProtoSelect = observer(
    class extends React.Component {
        state = {
            hover: false
        };

        handleMouseIn() {
            this.setState({ hover: true });
        }

        handleMouseOut() {
            this.setState({ hover: false });
        }

        handleChange = ({ target }) => {
            this.props.updateState(target.value);
        };

        render() {
            const { optionsValue, optionsName, ...props } = this.props;

            const tooltipStyle = {
                display: this.state.hover ? 'block' : 'none',
                position: 'absolute',
                right: 0,
                margin: 0,
                top: '5px',
                backgroundColor: '#c1272d',
                width: '70%',
                padding: '5px'
            };

            let optionNodes = [];
            if (optionsValue && optionsName) {
                for (let k = 0; k < optionsValue.length; k++) {
                    optionNodes.push(
                        <Option key={optionsName[k]} value={optionsValue[k]}>
                            {optionsName[k]}
                        </Option>
                    );
                }
            }

            return (
                <Flex w={1} pt={'3px'} pb={'3px'}>
                    <BoxTemplate textalign="left" w={1 / 2}>
                        <Label textStyle="labelNormal">
                            {this.props.label}
                        </Label>
                    </BoxTemplate>
                    <Box w={1 / 2}>
                        <div
                            onMouseOver={this.handleMouseIn.bind(this)}
                            onMouseOut={this.handleMouseOut.bind(this)}
                        >
                            <Select
                                {...props}
                                value={this.props.statevariable.userchanging}
                                onChange={this.handleChange}
                            >
                                {optionNodes}
                            </Select>
                        </div>
                        {this.props.errormask && (
                            <BoxTemplate position="relative">
                                <BoxTemplate style={tooltipStyle}>
                                    <Label color="white" textStyle="labelSmall">
                                        This value cannot be empty
                                    </Label>
                                </BoxTemplate>
                            </BoxTemplate>
                        )}
                    </Box>
                </Flex>
            );
        }
    }
);

export default observer(ProtoSelect);



// WEBPACK FOOTER //
// ./src/uic/Select.js